<template>
  <!-- Navbar top Without Logout ad Other Components -->
  <div class="mat-toolbar">
    <div class="mat-navbar">
      <nav id="toolbar" class="bg-secondary-light-mew">
        <div class="row no-gutters align-items-center flex-nowrap" style="height: 58px;">
          <div class="col">
            <div class="row no-gutters align-items-center flex-nowrap">
              <!-- <button type="button" class="toggle-aside-button btn btn-icon hidden-md-upp" style="z-index: 4;" v-on:click="select()">
								<i class="icon icon-menu text-white"></i>
							</button> -->
              <div class="shortcuts-wrapper row no-gutters align-items-center px-0 px-sm-0" style="z-index: 4;padding-left: 0px !important;">
                <div class="shortcuts row no-gutters align-items-center">
                  <a class="shortcut-button mx-1 app-title text-white menu-btn-hide" href="javascript:;" target="_blank">DigiCollect</a>
                </div>
              </div>
            </div>
          </div>
          <div class="center-logo navbar-header">
            <router-link class="navbar-branddigi" to="/accounttype">
              <span class="navlogo">
                <i class="logo-crm"></i>
              </span>
              <span class="dark-logo hidden-sm-down">
                DigiCRM
              </span>
            </router-link>
          </div>
          <div class="col-auto mr-6">
            <div class="row no-gutters align-items-center justify-content-end">
              <div class="language-button dropdown timezone-button">
                <div class="dropdown-toggle row align-items-center justify-content-center no-gutters px-0 px-sm-4 btn btn-icon text-white products-button" role="button" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <div class="row no-gutters align-items-center">
                    <!-- <span class="flag flag-in"></span> -->
                    <span class="text-white" v-if="selectedTimeZone==''">
                      {{timeDefault}}
                    </span>
                    <span class="text-white" v-if="selectedTimeZone=='America/New_York'">
                      {{timeNewYork}}
                    </span>
                    <span class="text-white" v-if="selectedTimeZone=='Europe/London'">
                      {{timeLondon}}
                    </span>
                    <span class="text-white" v-if="selectedTimeZone=='Asia/Kolkata'">
                      {{timeKolkata}}
                    </span>
                    <span class="text-white" v-if="selectedTimeZone=='Asia/Singapore'">
                      {{timeSingapore}} SGT
                    </span>
                    <span class="text-white" v-if="selectedTimeZone=='Asia/Yangon'">
                      {{timeYangon}} MMT
                    </span>
                  </div>
                </div>
                <div class="dropdown-menu dropdown-time" aria-labelledby="dropdownLanguageMenu">
                  <a class="dropdown-item">
                    <div class="row no-gutters align-items-center flex-nowrap">
                      <!-- <span class="flag flag-us"></span> -->
                      <span class="px-3" v-on:click=' guess = false, newyork = true, london=false, kolkata=false, singapore=false, yangon=false, setTimeZone("America/New_York") '>{{timeNewYork}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item">
                    <div class="row no-gutters align-items-center flex-nowrap">
                      <!-- <span class="flag flag-sg"></span> -->
                      <span class="px-3" v-on:click=' guess = false, newyork = false, london=true, kolkata=false, singapore=false, yangon=false, setTimeZone("Europe/London")'>{{timeLondon}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item">
                    <div class="row no-gutters align-items-center flex-nowrap">
                      <!-- <span class="flag flag-mm"></span> -->
                      <span class="px-3" v-on:click=' guess = false, newyork = false, london=false, kolkata=true, singapore=false, yangon=false, setTimeZone("Asia/Kolkata")'>{{timeKolkata}}</span>
                    </div>
                  </a>
                  <a class="dropdown-item">
                    <div class="row no-gutters align-items-center flex-nowrap">
                      <!-- <span class="flag flag-sg"></span> -->
                      <span class="px-3" v-on:click=' guess = false, newyork = false, london=false, kolkata=false, singapore=true, yangon=false, setTimeZone("Asia/Singapore")'>{{timeSingapore}} SGT</span>
                    </div>
                  </a>
                  <a class="dropdown-item">
                    <div class="row no-gutters align-items-center flex-nowrap">
                      <!-- <span class="flag flag-sg"></span> -->
                      <span class="px-3" v-on:click=' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=true, setTimeZone("Asia/Yangon")'>{{timeYangon}} MMT</span>
                    </div>
                  </a>
                  <!-- <a class="dropdown-item">
										<div class="row no-gutters align-items-center flex-nowrap">
											<span class="px-3" v-on:click=' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, thailand=true, setTimeZone("Asia/Thailand")'>{{timeThailand}} +07</span>
										</div>
									</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
export default {
  data() {
    return {
      toggleSideBar: false,
      togglemenu: true,
      timeDefault: moment()
        .tz(moment.tz.guess())
        .format("LTS z"),
      timeNewYork: moment()
        .tz("America/New_York")
        .format("LTS z"),
      timeLondon: moment()
        .tz("Europe/London")
        .format("LTS z"),
      timeKolkata: moment()
        .tz("Asia/Kolkata")
        .format("LTS z"),
      timeSingapore: moment()
        .tz("Asia/Singapore")
        .format("LTS"),
      timeYangon: moment()
        .tz("Asia/Yangon")
        .format("LTS"),
      timedefault: "",
      guess: true,
      newyork: false,
      london: false,
      kolkata: false,
      singapore: false,
      yangon: false,
      selectedTimeZone: "",
    };
  },
  methods: {
    select() {
      EventBus.$emit("topBar", true);
    },
    setTimeZone(timezone) {
      this.$store.dispatch("setTimezone", timezone);
    },
  },
  mounted: function() {
    setInterval(() => {
      (this.timeDefault = moment()
        .tz(moment.tz.guess())
        .format("HH:mm:ss z")),
        (this.timeNewYork = moment()
          .tz("America/New_York")
          .format("HH:mm:ss z")),
        (this.timeLondon = moment()
          .tz("Europe/London")
          .format("HH:mm:ss z")),
        (this.timeKolkata = moment()
          .tz("Asia/Kolkata")
          .format("HH:mm:ss z")),
        (this.timeSingapore = moment()
          .tz("Asia/Singapore")
          .format("HH:mm:ss")),
        (this.timeYangon = moment()
          .tz("Asia/Yangon")
          .format("HH:mm:ss"));
    }, 1000),
      EventBus.$on("navBarClick", toggle => {
        this.isHidden = !this.isHidden;
        this.togglemenu = !this.togglemenu;
      });
  },
  computed: {},
};
</script>

<style>
#toolbar {
  height: 58px !important;
  min-height: 58px !important;
}
.bg-secondary-light-mew{
  background: #005dae!important;
    border-radius: 10px !important;
}
#toolbar {
  -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0),
    0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 1px 3px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0),
    0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 1px 3px 0px rgba(0, 0, 0, 0);
}
#toolbar .toggle-aside-button,
#toolbar .search-button,
#toolbar .quick-panel-button {
  height: 50px !important;
  width: 56px !important;
  padding-right: 0px !important;
}
#toolbar .user-menu-button > #dropdownUserMenu {
  height: -webkit-fill-available !important;
  padding-right: 24px !important;
}
.app-title {
  padding-left: 0px !important;
  margin-left: 0px !important;
}
i.dg-products-icons.md-36 {
  font-size: 36px !important;
  vertical-align: -36px;
  line-height: 36px;
  height: 36px;
  width: 36px;
  padding-bottom: 15px;
  color: rgb(13, 132, 242) !important;
}
.app-title.menu-btn-hide {
  padding-left: 15px !important;
}
.bg-secondary-light {
  background-image: linear-gradient(
    to right,
    #00448b,
    #00448b 51%,
    #69b3fc,
    #9fcbff
  ) !important;
}
.center-logo.navbar-header {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  line-height: 40px;
  text-align: center !important;
  margin-top: 1px;
  height: 58px;
}
.center-logo.navbar-header .navbar-branddigi {
  margin-right: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
  font-size: 20px;
  color: rgba(255, 255, 255, 1);
  text-decoration: none !important;
}
@media screen and (min-width: 400px) {
  .center-logo.navbar-header .navbar-branddigi span.navlogo {
    padding: 0.8rem 0.5rem 0rem 0.3rem !important;
  }
}
@media screen and (min-width: 648px) {
  .center-logo.navbar-header .navbar-branddigi span.navlogo {
    padding: 0.8rem 0.5rem 0rem 0.3rem !important;
  }
}

@media screen and (max-width: 1025px) {
  .center-logo.navbar-header .navbar-branddigi span.navlogo {
    padding: 0.8rem 0.5rem 0rem 0.3rem;
  }
}
@media (max-width: 1060px) {
  .language-button {
    display: none !important;
  }
}
.center-logo.navbar-header .navbar-branddigi span.navlogo {
  font-weight: 600;
  padding: 0rem 0.5rem 0rem 0.3rem;
  text-transform: none;
  border-color: transparent;
  display: inline-block;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
  -webkit-appearance: none;
  outline: 0;
  color: rgba(255, 255, 255, 1);
}
.center-logo.navbar-header .navbar-branddigi span.dark-logo {
  font-weight: 600;
  padding: 0.8rem 0.4rem 0.8rem 0rem;
  text-transform: none;
  border-color: transparent;
  display: inline-block;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
  -webkit-appearance: none;
  outline: 0;
  color: #fff !important;
}
@media (min-width: 768px) {
  .navbar-header .navbar-branddigi {
    padding-top: 0px;
  }
}
.navbar-header .navbar-branddigi i {
  display: inline-block;
  color: rgba(255, 255, 255, 1);
  font-size: 22px;
}
.timezone-button .dropdown-toggle::after {
  color: #fff;
}
.flag {
  height: 32px;
  width: 32px;
  line-height: 20px;
  margin-right: 10px;
}
#contenttime {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: 0.5s;
  text-align: center;
}
#contenttime .wrappertime {
  margin-right: 10px;
}
#contenttime span {
  transition: 0.2s;
  font-size: 16px;
  margin: 0;
  font-weight: 600;
}
#contenttime p {
  transition: 0.2s;
}
.faded {
  opacity: 0;
  transition: 0.2s;
}
.timezone-button {
  line-height: 100%;
}
.clock {
  font-size: 24px;
  padding-right: 20px;
  color: #fff;
}
.uk-margin-top {
  height: 80px;
}
.dropdown-toggle.products-button::after {
  content: none !important;
}
@media (min-width: 576px) {
  .px-sm-32 {
    padding-left: 3.2rem !important;
  }
}
.app-title {
  font-size: 20px;
  font-weight: 600;
  /* padding: 0rem 3.4rem 0.8rem 0.3rem; */
  text-transform: none;
  min-width: initial;
  height: auto;
  line-height: normal;
  cursor: pointer;
  border-radius: 100% !important;
  background-color: transparent;
  border-color: transparent;
  text-decoration: none !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 0px solid transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  letter-spacing: 0.04em;
  -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0),
    0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0),
    0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0);
  -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1),
    -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  position: relative;
  outline: none;
  color: #fff !important;
}
div.content-app {
  padding-left: 15px;
  padding-right: 15px;
}

.base-box.boxed,
.base-box.boxed-inverse,
.boxed-inverse,
[class*="col-md-"].boxed,
[class*="col-md-"].boxed-inverse,
.grid-box > .grid-item.boxed-inverse,
.row.vertical-row > div.boxed-inverse,
.row.vertical-row > div.boxed {
  border-style: none !important;
}
.shadow-1,
.adv-img-down-text.shadow-1 .img-box,
.two-blocks-container.shadow-1 > .row,
.section-bg-color .advs-box.boxed-inverse,
.section-bg-color .adv-img.boxed-inverse {
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.13) !important;
}
.black {
  color: #212121 !important;
}
.col-center {
  float: none !important;
  margin-left: auto !important;
  margin-right: auto !important;
  clear: both;
  padding-top: 20px;
}

.section-bg-image .advs-box.boxed-inverse,
.black .flex-control-paging li a:hover,
.adv-img-down-text.boxed-inverse:hover,
.advs-box-multiple div.circle,
.list-blog input,
.list-blog select,
.section-bg-image [class*="col-md-"].boxed-inverse,
[class*="shadow-"].boxed-inverse,
.sidebar-nav ul ul,
.base-box.boxed,
.base-box.boxed-inverse,
.advs-box.boxed-inverse,
.section-bg-color .form-box .form-control,
.boxed-inverse:not(.shadow-1) .form-box,
.boxed-inverse:not(.shadow-1) .form-box .form-control,
.section-two-blocks .form-box .form-control,
.section-bg-color .advs-box.boxed-inverse {
  background-color: #fff;
}
hr.space {
  border: none !important;
  clear: both;
  height: 70px;
  margin: 0;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.text-l {
  line-height: 38px;
}

.text-l {
  font-size: 27px !important;
  line-height: 31px;
}
.grid-list {
  position: relative;
}
.grid-box.row {
  margin: -20px;
  width: calc(100% + 40px);
}
.grid-box > .grid-item {
  padding: 20px;
}

.app-box.app-box-top-bottom {
  display: block;
}
.grid-item > div {
  padding-left: 0;
  padding-right: 0;
}
.app-box-top-bottom .app-box-cell {
  display: block;
  text-align: center;
}
.app-box-cell {
  vertical-align: middle;
}
.app-box.app-box-top-bottom .app-box-cell > img {
  margin: 0px 0 15px 0;
}
.app-box.app-box-top-bottom .app-box-cell > img {
  float: none;
  margin: 7px 0 7px 0;
  display: inline-block;
}

.app-box-cell img.text-xl {
  width: 55px;
}
.app-box.app-box-top-bottom .app-box-cell > i {
  float: none;
  margin: 7px 0 7px 0;
  display: inline-block;
}
.app-box.app-box-top-bottom .app-box-cell > i {
  margin: 0px 0 15px 0;
  color: #5584ff;
}

.app-box-cell i.text-xl {
  width: 55px;
  font-size: 55px;
  height: 55px;
  line-height: 55px;
}
.app-box-top-bottom .app-box-cell label {
  margin-bottom: 10px;
}
.app-box-top-bottom .app-box-cell label {
  padding: 0;
}
.app-box label {
  font-weight: 600;
}
.app-box-top-bottom .app-box-cell p {
  padding: 0;
  margin-bottom: 0;
  margin: 0;
}
.grid-item p {
  height: auto;
}
.text-s {
  line-height: 20px;
  font-size: 13px !important;
}
body.fuse-aside-folded:not(.fuse-aside-expanded) #aside .aside-content-wrapper,
body.fuse-aside-folded:not(.fuse-aside-expanded)
  #aside
  .aside-content-wrapper
  > .aside-content {
  width: 0rem !important;
  min-width: 0rem !important;
}
body.fuse-aside-folded:not(.fuse-aside-expanded) #aside {
  width: 0rem;
}
.layout.layout-vertical.fuse-aside-folded.layout-left-navigation .wrapper {
  padding-left: 0rem;
}
/* .side-menu {
		  width: 281px;
		  position: fixed;
		  top: 0;
		  left: 0;
		  background: #fff;
		  height: 100%;
		  border-right: solid 1px #c5d6de;
		  overflow: auto;
		  z-index: 60;
		  padding: 90px 0 110px;
		  z-index: 1000;
		  -webkit-transition-property: width, min-width, max-width, -webkit-transform;
		  transition-property: width, min-width, max-width, -webkit-transform;
		  transition-property: transform, width, min-width, max-width;
		  transition-property: transform, width, min-width, max-width, -webkit-transform;
		  -webkit-transition-duration: 150ms;
		  transition-duration: 150ms;
		  -webkit-transition-timing-function: ease-in-out;
		  transition-timing-function: ease-in-out;
		  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
		  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
		} */
/* body.sidebar-hidden .side-menu {
		  display: none;
		} */
.layout > .aside > .aside-content-wrapper > .aside-content {
  width: 280px;
}
.layout > .aside > .aside-content-wrapper {
  width: 280px;
  min-width: 280px;
}
.nav-link {
  text-decoration: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  padding: 0 24px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  font-size: 14px;
}
.layout
  > .aside
  > .aside-content-wrapper
  > .aside-content
  > #sidenav
  .nav-link {
  color: #212121;
}
.nav-link i,
.nav-link [class^="icon-"],
.nav-link [class*=" icon-"] {
  font-size: 24px !important;
  margin-right: 1.9rem;
}
.dropdown-toggle.dropdownhideafter::after {
  content: none !important;
}

.dropdown-toggle.text-white::after {
  color: #fff !important;
}
.dropdown-apps {
  width: 320px;
  min-height: 100px;
  max-height: 400px;
  overflow-y: auto;
  top: 16px !important;
  left: -15px !important;
}
.dropdown-menu {
  -webkit-border-radius: 8px !important;
  border-radius: 8px !important;
  border: 1px solid #cdd2da !important;
  -webkit-box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
}
.dropdown-time {
  top: 11px !important;
}
.dropdown-search {
  width: 420px;
  min-height: 100px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  top: 10px !important;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  right: 1px;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-requests {
  width: 420px;
  min-height: 100px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  top: 10px !important;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  right: 1px;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-profiles {
  width: 340px;
  min-height: 100px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  top: 16px !important;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  right: 1px;
  z-index: 2;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.uk-margin-bottom {
  margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
  content: "";
  display: block;
  overflow: hidden;
}
[class*="uk-grid-width"] > * {
  box-sizing: border-box;
  width: 100%;
}
.uk-grid-width-medium-1-3 > * {
  width: 33.333%;
}
.uk-margin-top {
  margin-top: 15px !important;
}
@media (min-width: 1220px) {
  .uk-grid > * {
    padding-left: 0px;
  }
}
.uk-grid > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  margin: 0;
  float: left;
  text-align: center;
  text-decoration: none;
}
.uk-grid > *:hover {
  text-decoration: none;
}
i.dg-icons.md-36 {
  font-size: 36px !important;
  vertical-align: -36px;
  line-height: 36px;
  height: 36px;
  width: 36px;
  padding-bottom: 15px;
  color: #00448b !important;
}
.uk-grid > * > :last-child {
  margin-bottom: 0;
}
.uk-text-muted {
  color: #212121 !important;
}
.uk-display-block {
  display: block !important;
}
.logoblock .uk-display-block {
  margin-top: 8px;
}
.products-button {
  height: 3.4rem !important;
  line-height: 3.4rem !important;
  border-radius: 100px !important;
  border: 1px solid rgb(184, 223, 255) !important;
  padding: 0px 17.3px !important;
  text-transform: capitalize !important;
}
.md-theme-default a:not(.md-button):hover {
  color: inherit;
}
.md-theme-default a:not(.md-button) {
  color: inherit;
}
/* @media only screen and (max-width: 897px) {
  .app-title.menu-btn-hide {
    padding-left: 0px !important;
  }
} */
@media (min-width: 899px) {
  .hidden-md-upp {
    display: none !important;
  }
}
.searchContent {
  background-color: #4b9be6;
  color: white;
  border-radius: 50%;
}
.searchFilter {
  width: 7.3px;
  height: 10.7px;
}
.searchProducts {
  width: 375px;
  height: 34px;
  border-radius: 100px !important;
  border: solid 1px #d5d5d5 !important;
  padding-left: 35px;
  padding-right: 35px;
  background-image: linear-gradient(
    to bottom,
    #efefef,
    #ffffff 25%,
    #ffffff 48%,
    #ffffff 78%,
    #efefef
  );
}
.searchIcon {
  color: #cfcfcf !important;
  position: absolute;
  pointer-events: cursor;
  top: 22px;
  font-size: 19px;
  left: 15px;
  display: inline-block;
}
.closeIcon {
  color: #cdd2da !important;
  position: absolute;
  pointer-events: cursor;
  top: 22px;
  font-size: 19px;
  right: 10px;
  display: inline-block;
}
.searchTitle {
  top: 0px;
  position: relative;
}
/* .profileSearch.activatedsearch {
  overflow-y: auto;
  height: 210px;
  overflow-x: hidden;
} */
.searchProductContent {
  height: 21px;
  width: 14px;
}
.avatar.avatar-grey {
  background-color: #cdd2da;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.28px;
  color: #ffffff;
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}
.input-search-rounded-box {
  position: relative;
}
.input-search-rounded-box .input-search-close,
.input-search-rounded-box .input-search-icon {
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 2.573rem;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.input-search-rounded-box .input-search-icon {
  left: 8px;
  font-size: 16px;
  color: #9e9e9e;
  text-align: center;
  pointer-events: none;
}
.input-search-rounded-box .input-search-icon + .form-control {
  padding-left: 38px !important;
}
.input-search-rounded-box .form-control {
  border-radius: 200px !important;
}
.input-search-close.icon {
  font-size: inherit !important;
  line-height: inherit !important;
}
button.input-search-close {
  -webkit-appearance: none !important;
  padding: 0 !important;
  cursor: pointer !important;
  background: 0 0 !important;
  border: 0 !important;
}
.input-search-rounded-box .input-search-close {
  right: 8px !important;
  color: #cdd2da !important;
  font-size: 19px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}
.input-search-rounded-box .form-control {
  height: 3.573rem !important;
  -webkit-appearance: none !important;
  border-color: #e0e0e0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -webkit-transition: -webkit-box-shadow 0.25s linear, border 0.25s linear,
    color 0.25s linear, background-color 0.25s linear !important;
  -o-transition: box-shadow 0.25s linear, border 0.25s linear,
    color 0.25s linear, background-color 0.25s linear !important;
  transition: box-shadow 0.25s linear, border 0.25s linear, color 0.25s linear,
    background-color 0.25s linear !important;
  -moz-appearance: none !important;
}
.input-search-rounded-box .form-control {
  display: block !important;
  width: 100% !important;
  padding: 0.429rem 1.072rem !important;
  font-size: 14px !important;
  line-height: 1.571429 !important;
  color: #4e5764 !important;
  background-color: #fff !important;
  -webkit-background-clip: padding-box !important;
  background-clip: padding-box;
  border: solid 1px #d5d5d5 !important;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#efefef),
    color-stop(25%, #ffffff),
    color-stop(48%, #ffffff),
    color-stop(78%, #ffffff),
    to(#efefef)
  ) !important;
  background-image: linear-gradient(
    to bottom,
    #efefef,
    #ffffff 25%,
    #ffffff 48%,
    #ffffff 78%,
    #efefef
  ) !important;
}
.searchfooter {
  height: 40px;
  box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #e5e5e5;
  line-height: 40px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.51px;
  color: #4e5764;
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.searchfooter:hover {
  color: #00448b;
}
.notifyheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  height: 100%;
  position: relative;
  background: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.notifyheader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #cdd2da;
}
.notifyheader > .descriptionheader .description-text-header-left h5 {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}
.notifyheader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #00448b;
  font-weight: 500;
}
.notifyheader > .descriptionheader .description-text-header-right {
  display: block;
}
/* .profileheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  position: relative;
  background: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.profileheader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 6px 10px;
  border-bottom: 1px solid transparent;
}
.profileheader > .descriptionheader .description-text-header-left h5 {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}
.profileheader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #00448b;
  font-weight: 500;
}
.profileheader > .descriptionheader .description-text-header-right {
  display: block;
}
.profileheader > .descriptionheader .description-text-header-right span {
  width: 26px !important;
  height: 26px;
  line-height: 28px;
  background: #f5f6f9;
  border-radius: 50%;
  text-align: center;
  display: block;
  cursor: pointer;
}
.profileheader > .descriptionheader .description-text-header-right span i {
  font-size: 17px;
  width: 17px !important;
  height: 17px;
  line-height: 17px;
  color: #00448b;
} */
.dropdown-menu-header {
  position: relative;
  padding: 20px 20px;
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu-header > h5 {
  margin: 0;
}
.dropdown-menu-header .badge {
  position: absolute;
  top: 50%;
  right: 20px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.countnotification {
  position: absolute;
  bottom: 3.3rem;
  right: 0.4rem;
  color: #fff !important;
  background: #ff9a06;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 600;
}
.list-group.profile-group .list-group-item.three-line {
  min-height: 6.8rem;
  border-bottom: 1px solid #cdd2da;
}
.list-group.profile-group .list-group-item.three-line:last-child {
  border-bottom: 1px solid transparent;
  margin-bottom: 25px;
}
.list-group.profile-group .list-group-item:hover,
.list-group.profile-group .list-group-item:focus {
  z-index: 0;
  text-decoration: none;
}
.list-group.profile-group .list-group-item h3 {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #303031 !important;
  margin: 0;
}
.list-group.profile-group .list-group-item h4 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #4e5764 !important;
}
.list-group.profile-group .list-group-item p.compname {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #00448b !important;
}
.profile-selected .list-group .list-group-item h3 {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #303031 !important;
  margin: 0;
}
.profile-selected .list-group .list-group-item p {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #4e5764 !important;
}
.btn-personal {
  height: 28px !important;
  padding: 0 12px !important;
  border-radius: none !important;
  font-size: 13px !important;
  line-height: 28px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  text-decoration: underline !important;
}
.btn-logout {
  height: 28px !important;
  padding: 0 18px !important;
  border-radius: 18px !important;
  font-size: 12px !important;
  line-height: 28px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}
.profilefooter {
  height: 45px;
  box-shadow: none;
  background-color: #f7f7f7;
  line-height: 45px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.51px;
  color: #4e5764;
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.profilefooter:hover {
  color: #00448b;
}
.grey-border-box {
  border: dashed 1px #cdd2da;
  padding: 11px 20px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.92;
  letter-spacing: 0.56px;
  text-align: center;
  color: #9e9e9e;
  width: 265px;
  margin: 0 auto;
  border-radius: 12px;
}
.search-user-company-blocks {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.productSearch .contact .search-user-company-blocks .mailtext,
.productSearch .contact .search-user-company-blocks .user-company-name {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavTop.vue